import React from 'react'
import { Helmet } from 'react-helmet'

import Reviews from '../components/reviews'
import FAQs from '../components/faqs'
import Footer from '../components/footer'
import Navbar from '../components/home/Navbar'
import Hero from '../components/home/Hero'
import BirthdayPartyInquiry from '../components/birthday-party'

import './home.css'

// All-you-can-play Kent callout (WEB-Q21, Lily 2026-09-03): WRITTEN BUT
// HIDDEN until Lily flips this flag - Kent's Wed/Thu hours are currently
// too unstable to advertise. Flip to true + redeploy hosting to show it.
const SHOW_ALL_YOU_CAN_PLAY = false

const Home = () => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Lucky Claww - Seattle Claw Machine Arcade</title>
        <meta property="og:title" content="Lucky Claww - Seattle Claw Machine Arcade" />
        <link rel="icon" type="image/png" href="/lc-logo.png" />
      </Helmet>
      <Hero>
        <header className="home-header10">
          <Navbar />
        </header>
      </Hero>
      <div id="how-to-play" className="home-section">
        <div className="home-header-container">
          <div className="home-header">
            <h2 className="home-heading">
              <i className="fas fa-gamepad heading-icon-left"></i>
              <span>How to Play</span>
              <i className="fas fa-gift heading-icon-right"></i>
              <i className="fas fa-crown heading-icon-right"></i>
            </h2>
          </div>
        </div>
        <div className="home-steps">
          <div className="home-step">
            <div className="home-step-number">1</div>
            <div className="home-step-content">
              <img
                alt="Purchase Coins"
                src="/steps/step1.jpeg"
                className="home-step-image"
              />
              <h3>Purchase Coins</h3>
              <p>Start by choosing one of our coin packages below. <strong>Each package comes with a guaranteed plushie points, so you'll always win something</strong> — even if the claws get tricky!</p>
            </div>
          </div>
          <div className="home-step">
            <div className="home-step-number">2</div>
            <div className="home-step-content">
              <img
                alt="Play and Have Fun"
                src="/steps/step2.jpg"
                className="home-step-image"
              />
              <h3>Play and Win</h3>
              <p>Each prize you catch from the machines is worth plushie points. If you've used up all your tokens but haven't reached the guaranteed number of points from your package, <strong>we'll either add points or give you extra tokens until you do!</strong></p>
            </div>
          </div>
          <div className="home-step">
            <div className="home-step-number">3</div>
            <div className="home-step-content">
              <img
                alt="Upgrade or Trade"
                src="/steps/step3.png"
                className="home-step-image"
              />
              <h3>Upgrade Prizes</h3>
              <p>You can keep the plushies you love and trade in the ones you don’t for plushie points to get other prizes or upgrade to bigger plushies from our prize wall 🎁 It's just like an arcade ticket system — but way cuter!</p>
            </div>
          </div>
        </div>
      </div>
      <section id="token-packages" className="home-comparision">
        <div className="home-header-container2">
          <div className="home-header12">
            <h2 className="home-heading11">
              <i className="fas fa-coins heading-icon-left"></i>
              <span>Packages</span>
              <i className="fas fa-star heading-icon-right"></i>
              <i className="fas fa-star heading-icon-right"></i>
              <i className="fas fa-star heading-icon-right"></i>
            </h2>
          </div>
        </div>
        <div className="home-table">
          <div className="home-row10">
            <div className="home-plans1">
              <div className="home-row11">
                <span className="home-text22">Price</span>
                <span className="home-text23">Coin</span>
                <span className="home-text24"><em className="new-tag">Plushie Points</em></span>
              </div>
            </div>
          </div>
          <div className="home-row12">
            <div className="home-plans2">
              <div className="home-row13">
                <div className="value">
                  <span className="home-text25">$20</span>
                </div>
                <div className="value">
                  <span className="home-text26">22</span>
                </div>
                <div className="value">
                  <span className="home-text27">6</span>
                </div>
              </div>
            </div>
          </div>
          <div className="home-row14">
            <div className="home-plans3">
              <div className="home-row15">
                <div className="value">
                  <span className="home-text28">$56</span>
                </div>
                <div className="value">
                  <span className="home-text29">100</span>
                </div>
                <div className="value">
                  <span className="home-text30">20</span>
                </div>
              </div>
            </div>
          </div>
          <div className="home-row16">
            <div className="home-plans4">
              <div className="home-row17">
                <div className="value">
                  <span className="home-text31">$80</span>
                </div>
                <div className="value">
                  <span className="home-text32">160</span>
                </div>
                <div className="value">
                  <span className="home-text33">32</span>
                </div>
              </div>
            </div>
          </div>
          <div className="home-row18">
            <div className="home-plans5">
              <div className="home-row19">
                <div className="value">
                  <span className="home-text34">$135</span>
                </div>
                <div className="value">
                  <span className="home-text35">280</span>
                </div>
                <div className="value">
                  <span className="home-text36">56</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {SHOW_ALL_YOU_CAN_PLAY && (
          <div
            className="home-all-you-can-play"
            style={{
              margin: 'var(--dl-space-space-twounits) auto 0',
              maxWidth: '640px',
              padding: 'var(--dl-space-space-oneandhalfunits)',
              borderRadius: '16px',
              border: '3px solid #a855f7',
              background: '#faf5ff',
              textAlign: 'center',
            }}
          >
            <h3 style={{ color: '#a855f7', marginTop: 0 }}>
              🎮 ALL-YOU-CAN-PLAY - KENT ONLY
            </h3>
            <p style={{ margin: '8px 0', fontWeight: 600 }}>
              Wednesdays &amp; Thursdays - $20/person + tax
            </p>
            <p style={{ margin: '8px 0' }}>
              One hour of unlimited claw machine play! Prizes return to the
              machines as you play - at the end, pick ONE machine-won prize
              to take home. No points, stamps, or trade-ins with this pass.
            </p>
            <p style={{ margin: '8px 0', color: '#6b7280' }}>
              Hours vary - check us on Google Maps before you visit.
            </p>
          </div>
        )}
      </section>
      <BirthdayPartyInquiry />
      <section id="locations" className="home-section">
        <div className="home-header-container">
          <div className="home-header">
            <h2 className="home-heading">Location & Hours</h2>
          </div>
        </div>
        <div className="home-steps" style={{ gap: "var(--dl-space-space-fourunits)" }}>
          {/* Bellevue Store */}
          <div className="home-step" style={{ flex: "1" }}>
            <div className="home-step-number">📍</div>
            <div className="home-step-content">
              <h3>Bellevue Store<br />(Highlands Plaza 2nd floor)</h3>
              <p style={{ marginBottom: "var(--dl-space-space-unit)" }}>
                14028 Bel-Red Rd, Unit 207<br />
                Bellevue, WA 98007<br />
                <a 
                  href="mailto:luckyclaww@gmail.com"
                  style={{ 
                    color: '#6caeec', 
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginTop: '8px'
                  }}
                >
                  <i className="fas fa-envelope"></i>
                  luckyclaww@gmail.com
                </a>
              </p>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2689.05626720376!2d-122.15281410000001!3d47.6250375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54906db362f3a527%3A0xa3b1308dfda2e933!2sLucky%20Claww%20(Lucky%20Claw)!5e0!3m2!1sen!2sus!4v1762464412657!5m2!1sen!2sus"
                className="home-step-image"
                style={{ height: "250px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          
          {/* Kent Store */}
          <div className="home-step" style={{ flex: "1" }}>
            <div className="home-step-number">📍</div>
            <div className="home-step-content">
              <h3>Kent Store</h3>
              <p style={{ marginBottom: "var(--dl-space-space-unit)" }}>
              222 Washington Ave S<br />
              Kent, WA 98032<br />
                <a 
                  href="mailto:luckyclaww@gmail.com"
                  style={{ 
                    color: '#6caeec', 
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginTop: '8px'
                  }}
                >
                  <i className="fas fa-envelope"></i>
                  luckyclaww@gmail.com
                </a>
              </p>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2701.645557968058!2d-122.24590219999997!3d47.379835899999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905b37f784d923%3A0xc0d6a4cabbc1c964!2sLucky%20Claww%20Kent%20(Lucky%20Claw)!5e0!3m2!1sen!2sus!4v1768122616155!5m2!1sen!2sus"
                className="home-step-image"
                style={{ height: "250px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
        
        {/* Business Hours - Separate Row */}
        <div className="home-steps" style={{ gap: "var(--dl-space-space-fourunits)", marginTop: "var(--dl-space-space-fourunits)" }}>
          <div className="home-step" style={{ flex: "1", maxWidth: "100%" }}>
            <div className="home-step-number">🕒</div>
            <div className="home-step-content">
              <h3>Business Hours</h3>
              <p>Please check Google Maps for the up-to-date business hours.</p>
            </div>
          </div>
        </div>
      </section>
      <Reviews />
      <FAQs />
      
      <Footer />
    </div>
  )
}

export default Home
